enum Partner {
  App = 'app',
  LoanBuilder = 'lb',
  PayPal = 'paypal',
  Sba = 'sba',
}

export default Partner;
